import React, { useState, useEffect } from 'react';
import { MultiSelect } from "react-multi-select-component";

interface OrgsSelectProps {
  options: Array<{
    label: string,
    value: number,
  }>;
  selectedItems: Array<{
    label: string,
    value: number,
  }>
  handleChange: (items) => void;
  label: string;
}

const Filter = ({ options, selectedItems, handleChange, label}: OrgsSelectProps) => {
  const [selected, setSelected] = useState(selectedItems);

  useEffect(() => {
    setSelected(selectedItems);
  }, [selectedItems]);

  const onChange = (newValue) => {
    setSelected(newValue);
    handleChange(newValue);
  };

  return (
    <div className="mx-2">
      <span>{label}</span>
      <div className="w-100 dropdown-container-wrapper">
        <MultiSelect
          options={options}
          value={selected}
          hasSelectAll
          onChange={onChange}
          labelledBy="Select"
        />
      </div>
    </div>
  );
};

export default Filter;
